import { FC, ForwardRefExoticComponent, ReactNode, useEffect, useLayoutEffect, useRef } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { ActivityIndicator } from 'react-native-paper'
import { ColorsEnum } from '../../../constants/colors'
import MenuPaper from './MenuPaper'

interface MenuProps {
    children: ReactNode
    title?: string
    open: boolean
    progressAnimating?: boolean
    onPress: () => void
    onDismiss: () => void
    Button: ForwardRefExoticComponent<any>
}

const Menu: FC<MenuProps> = ({
    children,
    title,
    open,
    progressAnimating = true,
    onPress,
    onDismiss,
    Button,
}) => {
    const buttonRef = useRef<View>(null)
    const menuPaperContainerRef = useRef<View>(null)
    const menuContainerStyleRef = useRef<StyleProp<ViewStyle>>(null)

    useEffect(() => {
        if (!children || !buttonRef.current || menuContainerStyleRef.current) return

        buttonRef.current!.measure((_, _1, width, _2, pageX, pageY) => {
            menuContainerStyleRef.current = {
                top: pageY - 4,
                left: pageX + width,
            }
        })
    }, [children])

    useLayoutEffect(() => {
        if (!open || !menuPaperContainerRef.current) return

        menuPaperContainerRef.current.setNativeProps({ style: menuContainerStyleRef.current })
    }, [open])

    if (!children) {
        return (
            <ActivityIndicator
                animating={progressAnimating}
                color={ColorsEnum.SUCCESS}
                size={34}
                style={{ marginRight: 40 }}
            />
        )
    }

    return (
        <>
            {title ? (
                <Button onPress={onPress} ref={buttonRef}>
                    {title}
                </Button>
            ) : (
                <Button onPress={onPress} ref={buttonRef} />
            )}
            <MenuPaper open={open} onDismiss={onDismiss} ref={menuPaperContainerRef}>
                {children}
            </MenuPaper>
        </>
    )
}

export default Menu
